import React, {useEffect, useState} from 'react';
import * as Sentry from '@sentry/react';
import {reloadOnceOnStaleChunk} from './chunkReload';

const loadMessagingCenter = () =>
  import(/* webpackChunkName: "MessagingCenter" */ '../modules/Messaging');

export const LazyMessagingCenter: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadMessagingCenter}>
      {(Module: any) =>
        Module.MessagingIndex ? <Module.MessagingIndex {...props} /> : null
      }
    </LazyLoader>
  );
};
const loadEditProfile = () =>
  import(
    /* webpackChunkName: "EditProfile" */ '../modules/Profile/EditProfile/EditProfile'
  );

export const LazyEditProfile: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadEditProfile}>
      {(Module: any) =>
        Module.EditProfile ? <Module.EditProfile {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadPublicProfileRouter = () =>
  import(
    /* webpackChunkName: "PublicProfileRouter" */ '../modules/Profile/PublicProfile/PublicProfileRouter'
  );

export const LazyPublicProfileRouter: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadPublicProfileRouter}>
      {(Module: any) =>
        Module.PublicProfileRouter ? (
          <Module.PublicProfileRouter {...props} />
        ) : null
      }
    </LazyLoader>
  );
};
const loadRequestForProposalsList = () =>
  import(
    /* webpackChunkName: "RequestForProposalsList" */ '../modules/ListViews/RequestForProposalsList'
  );

export const LazyRequestForProposalsList: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadRequestForProposalsList}>
      {(Module: any) =>
        Module.RequestForProposalsList ? (
          <Module.RequestForProposalsList {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadVerificationWizard = () =>
  import(
    /* webpackChunkName: "VerificationWizard" */ '../modules/IdentityVerification/VerificationWizard'
  );

export const LazyVerificationWizard: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadVerificationWizard}>
      {(Module: any) =>
        Module.VerificationWizard ? (
          <Module.VerificationWizard {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadArticlesList = () =>
  import(
    /* webpackChunkName: "ArticlesList" */ '../modules/HelpArticles/HelpArticlesList'
  );

export const LazyArticlesList: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadArticlesList}>
      {(Module: any) =>
        Module.HelpArticlesList ? <Module.HelpArticlesList {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadHelpArticle = () =>
  import(
    /* webpackChunkName: "HelpArticle" */ '../modules/HelpArticles/HelpArticle'
  );

export const LazyHelpArticle: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadHelpArticle}>
      {(Module: any) =>
        Module.HelpArticle ? <Module.HelpArticle {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadCKEditor = () =>
  import(/* webpackChunkName: "CKEditor" */ './CKEditor');

export const LazyCKEditor: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadCKEditor}>
      {(Module: any) =>
        Module.CKEditor ? (
          <Module.CKEditor
            {...props}
            style={{width: window.outerWidth <= 600 ? '100%' : 500}}
          />
        ) : null
      }
    </LazyLoader>
  );
};

const loadInsuranceQualifications = () =>
  import(
    /* webpackChunkName: "InsuranceQualificationsDialog" */ './dialogs/InsuranceQualifications'
  );

export const LazyInsuranceQualifications: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadInsuranceQualifications}>
      {(Module: any) =>
        Module.InsuranceQualifications ? (
          <Module.InsuranceQualifications {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadSubscriptionsCheckout = () =>
  import(
    /* webpackChunkName: "SubscriptionsCheckout" */ '../modules/BidmiiProSubscriptions/checkout/SubscriptionsCheckout'
  );

export const LazySubscriptionsCheckout: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadSubscriptionsCheckout}>
      {(Module: any) =>
        Module.SubscriptionsCheckout ? (
          <Module.SubscriptionsCheckout {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadBidmiiProLandingPage = () =>
  import(
    /* webpackChunkName: "BidmiiProLandingPage" */ '../modules/BidmiiProSubscriptions/BidmiiProLandingPage'
  );

export const LazyBidmiiProLandingPage: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadBidmiiProLandingPage}>
      {(Module: any) =>
        Module.BidmiiProLandingPage ? (
          <Module.BidmiiProLandingPage {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadAccountingAnalytics = () =>
  import(
    /* webpackChunkName: "AccountingAnalytics" */ '../modules/ContractorAnalytics/AccountingAnalytics'
  );

export const LazyAccountingAnalytics: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadAccountingAnalytics}>
      {(Module: any) =>
        Module.AccountingAnalytics ? (
          <Module.AccountingAnalytics {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadProfileSettings = () =>
  import(
    /* webpackChunkName: "ProfileSettings" */ '../modules/Profile/EditProfile/components/ProfileSettings/ProfileSettings'
  );

export const LazyProfileSettings: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadProfileSettings}>
      {(Module: any) =>
        Module.ProfileSettings ? <Module.ProfileSettings {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadRequestQuoteDialog = () =>
  import(
    /* webpackChunkName: "RequestQuoteDialog" */ '../modules/ProWebsite/components/RequestQuoteDialog'
  );

export const LazyRequestQuoteDialog: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadRequestQuoteDialog}>
      {(Module: any) =>
        Module.RequestQuoteDialog ? (
          <Module.RequestQuoteDialog {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadContractorSearchList = () =>
  import(
    /* webpackChunkName: "ContractorSearchList" */ '../modules/FindContractors/ContractorSearchList'
  );

export const LazyContractorSearchList: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadContractorSearchList}>
      {(Module: any) =>
        Module.ContractorSearchList ? (
          <Module.ContractorSearchList {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadResourcesListView = () =>
  import(
    /* webpackChunkName: "ResourcesListView" */ '../modules/ResourcesMarketplace/ResourcesListView'
  );

export const LazyResourcesListView: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadResourcesListView}>
      {(Module: any) =>
        Module.ResourcesListView ? (
          <Module.ResourcesListView {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadFAQPage = () =>
  import(/* webpackChunkName: "FAQPage" */ '../modules/FAQPage/FAQPage');

export const LazyFAQPage: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadFAQPage}>
      {(Module: any) => (Module.FAQPage ? <Module.FAQPage {...props} /> : null)}
    </LazyLoader>
  );
};

const loadProWebsite = () =>
  import(
    /* webpackChunkName: "ProWebsite" */ '../modules/ProWebsite/ProWebsite'
  );

export const LazyProWebsite: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadProWebsite}>
      {(Module: any) =>
        Module.ProWebsite ? <Module.ProWebsite {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadContractorCostBreakdown = () =>
  import(
    /* webpackChunkName: "CostBreakdown" */ '../modules/ProposalForm/BidDetails/ContractorCostBreakdown'
  );

export const LazyContractorCostBreakdown: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadContractorCostBreakdown}>
      {(Module: any) =>
        Module.ContractorCostBreakdown ? (
          <Module.ContractorCostBreakdown {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadCostBreakdown = () =>
  import(
    /* webpackChunkName: "CostBreakdown" */ '../modules/ProposalForm/BidDetails/CostBreakdown'
  );

export const LazyCostBreakdown: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadCostBreakdown}>
      {(Module: any) =>
        Module.CostBreakdown ? <Module.CostBreakdown {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadReviewWizard = () =>
  import(
    /* webpackChunkName: "ReviewWizard" */ '../modules/ReviewWizard/ReviewWizard'
  );

export const LazyReviewWizard: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadReviewWizard}>
      {(Module: any) =>
        Module.ReviewWizard ? <Module.ReviewWizard {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadSupport = () =>
  import(/* webpackChunkName: "Support" */ '../modules/Support');

export const LazySupport: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadSupport}>
      {(Module: any) => (Module.Support ? <Module.Support {...props} /> : null)}
    </LazyLoader>
  );
};
const loadCategoriesList = () =>
  import(
    /* webpackChunkName: "CategoriesList" */ '../modules/FindContractors/CategoriesList'
  );

export const LazyCategoriesList: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadCategoriesList}>
      {(Module: any) =>
        Module.CategoriesList ? <Module.CategoriesList {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadLocationsList = () =>
  import(
    /* webpackChunkName: "LocationsList" */ '../modules/FindContractors/LocationsList'
  );

export const LazyLocationsList: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadLocationsList}>
      {(Module: any) =>
        Module.LocationsList ? <Module.LocationsList {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadSupportPopup = () =>
  import(
    /* webpackChunkName: "SupportPopup" */ '../modules/Support/SupportPopup'
  );

export const LazySupportPopup: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadSupportPopup}>
      {(Module: any) =>
        Module.SupportPopup ? <Module.SupportPopup {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadMain = () =>
  import(/* webpackChunkName: "Main" */ '../modules/Main/Main');

export const LazyMain: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadMain}>
      {(Module: any) => (Module.Main ? <Module.Main {...props} /> : null)}
    </LazyLoader>
  );
};
const loadMarketing = () =>
  import(
    /* webpackChunkName: "Marketing" */ '../modules/Marketing/MarketingPage'
  );

export const LazyMarketingPage: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadMarketing}>
      {(Module: any) =>
        Module.MarketingPage ? <Module.MarketingPage {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadMainContainer = () =>
  import(
    /* webpackChunkName: "MainContainer" */ '../modules/Main/MainContainer'
  );

export const LazyMainContainer: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadMainContainer}>
      {(Module: any) =>
        Module.MainContainer ? <Module.MainContainer {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadLogin = () =>
  import(/* webpackChunkName: "Login" */ '../modules/Login/Login');

export const LazyLogin: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadLogin}>
      {(Module: any) => (Module.Login ? <Module.Login {...props} /> : null)}
    </LazyLoader>
  );
};

const loadContactsCRM = () =>
  import(
    /* webpackChunkName: "ContactsCRM" */ '../modules/ContactsCRM/ContactsCRM'
  );

export const LazyContactsCRM: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadContactsCRM}>
      {(Module: any) =>
        Module.ContactsCRM ? <Module.ContactsCRM {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadOnboardingWizard = () =>
  import(
    /* webpackChunkName: "OnboardingWizard" */ '../modules/Onboarding/OnboardingWizard'
  );

export const LazyOnboardingWizard: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadOnboardingWizard}>
      {(Module: any) =>
        Module.OnboardingWizard ? <Module.OnboardingWizard {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadNewUserRouter = () =>
  import(
    /* webpackChunkName: "NewUserRouter" */ '../modules/NewUserWizard/NewUserRouter'
  );

export const LazyNewUserRouter: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadNewUserRouter}>
      {(Module: any) =>
        Module.NewUserRouter ? <Module.NewUserRouter {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadInvoicesTable = () =>
  import(
    /* webpackChunkName: "InvoicesTable" */ '../modules/Invoices/InvoicesTable'
  );

export const LazyInvoicesTable: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadInvoicesTable}>
      {(Module: any) =>
        Module.InvoicesTable ? <Module.InvoicesTable {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadHomeownerDashboard = () =>
  import(
    /* webpackChunkName: "HomeownerDashboard" */ '../modules/Home/HomeownerDashboard'
  );

export const LazyHomeownerDashboard: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadHomeownerDashboard}>
      {(Module: any) =>
        Module.HomeownerDashboard ? (
          <Module.HomeownerDashboard {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadContractorDashboard = () =>
  import(
    /* webpackChunkName: "ContractorDashboard" */ '../modules/Home/ContractorDashboard'
  );

export const LazyContractorDashboard: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadContractorDashboard}>
      {(Module: any) =>
        Module.ContractorDashboard ? (
          <Module.ContractorDashboard {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadStripePaymentFlow = () =>
  import(/* webpackChunkName: "StripePaymentFlow" */ './StripePaymentFlow');

export const LazyStripePaymentFlow: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadStripePaymentFlow}>
      {(Module: any) =>
        Module.StripePaymentFlow ? (
          <Module.StripePaymentFlow {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadBidmiiLottieWrapper = () =>
  import(
    /* webpackChunkName: "BidmiiLottieWrapper" */ '../common/BidmiiLottieWrapper'
  );

export const LazyBidmiiLottieWrapper: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadBidmiiLottieWrapper}>
      {(Module: any) =>
        Module.BidmiiLottieWrapper ? (
          <Module.BidmiiLottieWrapper {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadEditRequestForProposal = () =>
  import(
    /* webpackChunkName: "EditRequestForProposal" */ '../modules/ListViews/components/DetailDialogs/Sections/ProjectDetailsSections/EditRequestForProposal'
  );

export const LazyEditRequestForProposal: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadEditRequestForProposal}>
      {(Module: any) =>
        Module.EditRequestForProposal ? (
          <Module.EditRequestForProposal {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadProposalForm = () =>
  import(
    /* webpackChunkName: "ProposalForm" */ '../modules/ProposalForm/ProposalForm'
  );

export const LazyProposalForm: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadProposalForm}>
      {(Module: any) =>
        Module.ProposalForm ? <Module.ProposalForm {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadMyRfpDialog = () =>
  import(
    /* webpackChunkName: "MyRfpDialog" */ '../modules/ListViews/components/DetailDialogs/MyRfpDialog'
  );

export const LazyMyRfpDialog: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadMyRfpDialog}>
      {(Module: any) =>
        Module.MyRfpDialog ? <Module.MyRfpDialog {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadCommunityDialog = () =>
  import(
    /* webpackChunkName: "CommunityDialog" */ '../modules/ListViews/components/DetailDialogs/CommunityDialog'
  );

export const LazyCommunityDialog: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadCommunityDialog}>
      {(Module: any) =>
        Module.CommunityDialog ? <Module.CommunityDialog {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadFormsRouter = () =>
  import(/* webpackChunkName: "FormsRouter" */ '../modules/Forms/FormsRouter');

export const LazyFormsRouter: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadFormsRouter}>
      {(Module: any) =>
        Module.FormsRouter ? <Module.FormsRouter {...props} /> : null
      }
    </LazyLoader>
  );
};

const loadServiceOrderWizard = () =>
  import(
    /* webpackChunkName: "ServiceOrderCreationWizard" */ '../modules/ServiceOrderCreationWizard'
  );

export const LazyServiceOrderWizard: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadServiceOrderWizard}>
      {(Module: any) =>
        Module.ServiceOrderIndex ? (
          <Module.ServiceOrderIndex {...props} />
        ) : null
      }
    </LazyLoader>
  );
};

const loadContractorDialog = () =>
  import(
    /* webpackChunkName: "ContractorDialog" */ '../modules/ListViews/components/DetailDialogs/ContractorDialog'
  );

export const LazyContractorDialog: React.FC<any> = (props) => {
  return (
    <LazyLoader loadImport={loadContractorDialog}>
      {(Module: any) =>
        Module.ContractorDialog ? <Module.ContractorDialog {...props} /> : null
      }
    </LazyLoader>
  );
};

interface IProps {
  loadImport: () => Promise<any>;
  children?: (Module: any) => React.ReactNode;
}

// A failed dynamic import is almost always a stale deploy: the browser cached
// an old index.html whose chunk filenames no longer exist after a release.
// Detection + the cooldown-guarded reload live in ./chunkReload so the
// global window listeners and this lazy-load path share one key + cooldown.

const LazyLoader: React.FC<IProps> = (props) => {
  const [_module, setModule] = useState<any>(null);
  const [_error, setError] = useState<any>(null);
  const {loadImport} = props;

  useEffect(() => {
    loadImport()
      .then((mod: any) => {
        // Store the whole module namespace. Every child render function below
        // reads a *named* export off this object (e.g. `Module.EditProfile`),
        // so the namespace is exactly what they expect.
        //
        // Do NOT unwrap to `mod.default` here: when a module's default export
        // is a component (a function), passing it to a state setter makes React
        // treat it as a functional state updater and *invoke the component*
        // inside LazyLoader's own render. That runs the component's hooks
        // against LazyLoader's fiber and throws React error #310 "Rendered more
        // hooks than during the previous render" (BIDMII-CLIENT-51A). Modules
        // without a default export are unaffected (namespace was already used).
        setModule(mod);
      })
      .catch((err) => {
        // Stale-deploy chunk 404: reload once (cooldown-guarded) to fetch the
        // fresh index. Returns true if a reload was triggered.
        if (reloadOnceOnStaleChunk(err)) {
          return;
        }
        process.env.NODE_ENV === 'development' &&
          console.error('Failed to load module', err);
        Sentry.withScope(function (scope) {
          scope.setTag('section', 'LazyLoader.tsx useEffect()');
          Sentry.captureException(err);
        });
        setError(err);
      });
  }, [loadImport]);

  if (_module) {
    const t: string = typeof props.children;
    if (props.children && t === 'function') {
      return (props.children as (module: any) => JSX.Element)(_module);
    }
  }
  if (_error) {
    return (
      <div
        className="screen__container"
        style={{padding: '16px;', textAlign: 'center'}}>
        We have had an issue loading part of the application. <br />
        Please refresh your browser window
      </div>
    );
  }
  return <div className="screen__container" />;
};
